import { useLanguage } from '../../contexts/LanguageContext';
import { Globe } from 'lucide-react';

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2" data-testid="language-switcher">
      <Globe className="h-4 w-4 text-slate-400" />
      <div className="flex items-center bg-slate-100 rounded-lg p-0.5">
        <button
          onClick={() => setLanguage('en')}
          className={`px-2.5 py-1 text-xs font-medium rounded-md transition-all ${
            language === 'en'
              ? 'bg-white text-slate-900 shadow-sm'
              : 'text-slate-500 hover:text-slate-700'
          }`}
          data-testid="lang-en"
        >
          EN
        </button>
        <button
          onClick={() => setLanguage('cs')}
          className={`px-2.5 py-1 text-xs font-medium rounded-md transition-all ${
            language === 'cs'
              ? 'bg-white text-slate-900 shadow-sm'
              : 'text-slate-500 hover:text-slate-700'
          }`}
          data-testid="lang-cs"
        >
          CS
        </button>
      </div>
    </div>
  );
};
